import React, { useState } from 'react';
import styled from "styled-components";
import { OfficeEntity, updateSingleOfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { FlatContentCard } from '@shared/ui/atoms/FlatContentCard';
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';
import { SpaceBetweenRow } from "../../StyleComponents";
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { HorizontalSpacer } from '@shared/ui/atoms/VerticalSpacer';
import { OfficeCarParkingSetting } from "../../advance-hot-desking/components/OfficeCarParkingSetting";
import { useTranslation } from "react-i18next";
import { fetchOfficeEntities } from '@features/desks/store/advanceHotDeskingSetup.duck';
import { useDispatch } from "react-redux";

export function CarParkBookingPanel(props: Props) {
  const {t} = useTranslation();
  const {office} = props;
  const [carParkingCapacity, setCarParkingCapacity] = useState(office?.carParkCapacity ?? 0);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const onSaveClicked = async () => {
    if (!office) {
      return;
    }
    try {
      setLoading(true);
      await updateSingleOfficeEntity({...office, carParkCapacity: carParkingCapacity})
      dispatch(fetchOfficeEntities());
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container>
      <HeadlineMedium style={{marginBottom: 24}}>{t('settings.car-parking')}</HeadlineMedium>
      <FlatContentCard style={{marginBottom: 48}}>
        <BodyRegular weight={600}>{t('general.how-it-works')}</BodyRegular>
        <BodyRegular>{t('settings.car-parking-how-it-works')}</BodyRegular>
      </FlatContentCard>

      <HorizontalSpacer />

      <OfficeCarParkingSetting carParkingCapacity={carParkingCapacity}
                               isEditable={!loading}
                               onCarParkCapacityChange={setCarParkingCapacity} />

      <SpaceBetweenRow style={{marginTop: 32}}>
        <PrimaryButton click={onSaveClicked} text={'button.save-changes'} disabled={loading} />
      </SpaceBetweenRow>

    </Container>
  )
}

interface Props {
  office: OfficeEntity;
}

const Container = styled.div`
  
`
